import React from 'react'
import PropTypes from 'prop-types'
import { connect, useDispatch } from 'react-redux'
import { withStyles, useTheme } from '@material-ui/core/styles'
import {
  Drawer as UIDrawer, Hidden
} from '@material-ui/core'

import DrawerContent from './DrawerContent'
import { DRAWER_WIDTH } from './../../class/constants'
import { acDrawerToggle } from './../../class/actions'

const TemporaryDrawer = ({ classes, theme, children, open }) => {
  const dispatch = useDispatch()

  return (
    <UIDrawer
      variant='temporary'
      anchor={theme.direction === 'rtl' ? 'right' : 'left'}
      classes={{ paper: classes.drawerPaper }}
      ModalProps={{ keepMounted: true }}

      open={open}
      onClose={() => dispatch(acDrawerToggle())}
    >
      {children}
    </UIDrawer>
  )
}

const PermanentDrawer = ({ classes, children }) => {
  return (
    <UIDrawer
      variant='permanent'
      classes={{ paper: classes.drawerPaper }}
    >
      {children}
    </UIDrawer>
  )
}

function Drawer({ classes, selectedKey, onSelect, open }) {
  const theme = useTheme()

  const renderContent = () => (
    <DrawerContent selectedKey={selectedKey} onSelect={onSelect} />
  )

  return (
    <div>

      <Hidden smDown implementation='css'>
        <PermanentDrawer classes={classes}>
          {renderContent()}
        </PermanentDrawer>
      </Hidden>

      <Hidden mdUp implementation='css'>
        <TemporaryDrawer classes={classes} theme={theme} open={open}>
          {renderContent()}
        </TemporaryDrawer>
      </Hidden>
    </div>
  )
}

Drawer.propTypes = {
  onSelect: PropTypes.func
}

Drawer.defaultProps = {
  onSelect: () => true
}

const mapStateToProps = state => ({
  open: state.ReducerDrawer.open,
})

const styles = theme => ({
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: DRAWER_WIDTH,
      flexShrink: 0,
    },
  },
  drawerPaper: {
    width: DRAWER_WIDTH,
    background: theme.palette.background.shade01
  }
})

export default connect(mapStateToProps)(withStyles(styles)(Drawer))